module.exports = __webpack_public_path__ + "static/media/bts_lalela_170718_036_small.8d0601b7.jpg";